import { Component, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'redispatch-root',
    templateUrl: './app.component.html',
    styleUrls: [
        './app.component.scss',
    ],
    standalone: false,
})
export class AppComponent {

    private iconRegistry = inject(MatIconRegistry);
    private sanitizer = inject(DomSanitizer);

    private customIcons = [
        'innogy_picto_arrow-left',
        'innogy_picto_arrow-right',
        'innogy_picto_calendar-date-year',
        'innogy_picto_calendar-date',
        'innogy_picto_eye',
        'innogy_picto_cogeneration-unit',
        'innogy_picto_check',
        'innogy_picto_close',
        'innogy_picto_menu',
        'innogy_picto_clipboard',
        'innogy_picto_person',
        'innogy_picto_person_info',
        'innogy_picto_pylon',
        'innogy_picto_power_on_off',
        'innogy_picto_speech-bubble_exclamationmark',
        'innogy_picto_speech-bubble_questionmark',
        'innogy_picto_envelope_at',
        'innogy_picto_bin_c-check',
        'innogy_picto_c-check',
        'innogy_picto_c-plus',
        'innogy_picto_control-panel',
        'innogy_picto_double-arrow',
        'innogy_picto_home_large',
        'innogy_picto_windmill',
        'innogy_picto_magnifier',
        'innogy_picto_pen',
        'innogy_picto_attention',
    ];

    constructor() {
        this.customIcons.forEach(icon =>
            this.iconRegistry.addSvgIcon(
                icon,
                this.sanitizer.bypassSecurityTrustResourceUrl(`assets/innogy-icons/${icon}.svg`),
            ),
        );
        this.iconRegistry.addSvgIcon(
            'electricity',
            this.sanitizer.bypassSecurityTrustResourceUrl('assets/eon-evolution-core-icons/electricity.svg'),
        );
        this.iconRegistry.addSvgIcon(
            'consumption',
            this.sanitizer.bypassSecurityTrustResourceUrl('assets/eon-evolution-core-icons/consumption.svg'),
        );
    }
}
